import { BaseQuery, QueryConfig, QueryResponse, QueryResult } from "@/shared/types/base";
import { Barrio } from "@/shared/types/barrio";
import { removeNullOrEmptyKeys, sleep } from "@/shared/utils";
import { api } from "@/api";
import { useQuery } from "@tanstack/react-query";
import { ReactNode } from "react";

export interface BarriosQuery extends BaseQuery {
    nombre?: string;
    codigo?: string;
    ciudadId?: string;
}

export async function getAllBarrios(query?: BarriosQuery): Promise<QueryResponse<Barrio>> {
    await sleep(1000);
    const response = await api.get("barrios", { params: removeNullOrEmptyKeys(query) });
    return response.data;
}

export function useGetAllBarriosQuery(query: BarriosQuery = {}, queryConfig: QueryConfig<QueryResponse<Barrio>> = {}) {
    return useQuery({
        ...queryConfig,
        queryFn: async () => await getAllBarrios(query),
        queryKey: ["barrios", query],
    });
}

export interface GetAllBarriosQueryProps {
    query?: BarriosQuery;
    queryConfig?: QueryConfig<QueryResponse<Barrio>>;
    children: (queryResult: QueryResult<QueryResponse<Barrio>>) => ReactNode;
}

export function GetAllBarriosQuery({
    query,
    queryConfig,
    children,
}: GetAllBarriosQueryProps) {
    const queryResult = useGetAllBarriosQuery(query, queryConfig);
    return children && children(queryResult);
}